const { onlyAlphaNumeric, SPACE } = require('../helpers');

exports.zipCodeNormalize = (zipCode) => {
  if (!zipCode) {
    return zipCode;
  }
  const zip = onlyAlphaNumeric(zipCode);
  if (zip.length <= 4) {
    return zip;
  }
  return `${zip.slice(0, 4)} ${zip.slice(4, 6)}`;
};

exports.countryDefinition = {
  country: 'Netherlands',
  code: 'NL',
  schema: {
    company: { label: 'Company' },
    address: { label: 'Street Address' },
    address2: { label: 'Street Address 2' },
    city: { label: 'Town', width: 0.5 },
    zipCode: {
      label: 'Postal Code',
      width: 0.5,
      normalize: exports.zipCodeNormalize
    }
  },
  viewFormat: [
    ['company'],
    ['address'],
    ['address2'],
    ['zipCode', SPACE, 'city']
  ],
  formFormat: [['company'], ['address'], ['address2'], ['zipCode', 'city']],
  requiredFormFields: [
    { field: 'address' },
    { field: 'city' },
    {
      field: 'zipCode',
      validationRegex: new RegExp(/^[0-9]{4}[A-Za-z]{2}$/),
      error: 'Must be 6 characters, 1234 AB'
    }
  ]
};
